export default __webpack_public_path__ + "static/media/charm-s4.62e67414.png";